export function sectionHeadingTag(isFirst?: boolean): 'h1' | 'h2' {
	return isFirst ? 'h1' : 'h2';
}
